export default "__VITE_ASSET__cMNFcUat__"